import { render } from "./PhotoFeature.vue?vue&type=template&id=38fb6907&scoped=true"
import script from "./PhotoFeature.vue?vue&type=script&lang=js"
export * from "./PhotoFeature.vue?vue&type=script&lang=js"

import "./PhotoFeature.vue?vue&type=style&index=0&id=38fb6907&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fb6907"]])

export default __exports__